import Image from 'next/image';
import Star from 'public/star.svg';
import { Bar, Number, PercentageNumber, Progress, StarWrapper, Wrapper } from './ProgressBar.styled';
type Props = { number: number; percentage: number | null | undefined | any };
export default function ProgressBar({ number, percentage }: Props) {
  return (
    <Wrapper>
      <Number>{number}</Number>
      <StarWrapper>
        <Image src={Star} width={16} height={14} alt="star" />
      </StarWrapper>
      <Bar>
        <PercentageNumber>{percentage ? (percentage * 100).toFixed(0) : 0}%</PercentageNumber>
        <Progress style={{ width: `${(percentage * 100).toFixed(0)}%` }} />
      </Bar>
    </Wrapper>
  );
}
